"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { RadiusMd, SpaceSm } from "@nxt-costco-com/forge-design-tokens";
import { Link } from "../../Navigation/Link/index.js";
const PillSection = styled(Box)`
    list-style-type: none;
`;
const PillContentWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "wrapperBackgroundColor" && prop !== "wrapperHoverBackgroundColor"
})`
    display: flex;
    word-break: break-word;
    clip-path: polygon(0 0, 100% 0, calc(100% - 12px) 100%, 0% 100%);
    background-color: ${(props) => props.wrapperBackgroundColor};
    padding: 2px 0 2px 4px;
    border-radius: 3px 3px 0 3px;
    max-width: max-content;
    &:hover {
        background-color: ${(props) => props.wrapperHoverBackgroundColor};
    }
`;
const StyledLink = styled(Link)`
    max-width: 230px;
    min-height: 24px;
    cursor: pointer;
    text-decoration: none;
    display: inline-block;
    :focus-visible {
        outline: 2px solid Highlight;
        outline: 2px solid -webkit-focus-ring-color;
        outline-offset: 2px
        border-radius: ${RadiusMd}
    }
`;
const StyledShape = styled(Box)`
    width: ${SpaceSm};
`;
export {
  PillContentWrapper,
  PillSection,
  StyledLink,
  StyledShape
};
